import { get, post, postNL } from './request.js'
import { get1, post1 } from './loginRequest.js'


//发送短信
export const sendCode = (data, config) => get1(`/passport/main.zlongame`, data, config);
//手机账号+手机短信登录 查用户所有游戏账号信息 userid
export const phoneLogin = (data, config) => get1("/passport/method_login.zlongame", data, config);
//小程序手机账号一键登录
export const xcxPhoneLogin = (data) => get1("/passport/account/v2/user/login/onekey.do", data);
//系统共享传参登录
export const systemShareLogin = (data) => get1("passport/userv2/platform/info.do", data);

//会员登录
export const userLogin = (params) => post('/web/service', params, { 'func': 'MP' })
//签到记录查询
export const signInRecord = (params) => post('/web/service', params, { 'func': 'SR' })
//签到
export const signIn = (params) => post('/web/service', params, { 'func': 'MS' })
//会员中心项目列表
export const homeGameList = (params) => post('/web/service', params, { 'func': 'APP' })
//会员中心项目列表(未登录)
export const homeGameListNL = (params) => postNL('/web/service', params, { 'func': 'APPNL' })
//角色列表查询
export const queryRoleList = (params) => post('/web/service', params, { 'func': 'RO' })
//项目礼包
export const projectGift = (params) => post('/web/service', params, { 'func': 'GTP' })
//项目礼包(未登录)
export const projectGiftNL = (params) => postNL('/web/service', params, { 'func': 'GTPNL' })
//礼包详情
export const giftDetail = (params) => post('/web/service', params, { 'func': 'GTD' })
//领取礼包
export const giftReceive = (params) => post('/web/service', params, { 'func': 'GGT' })
//领券中心列表查询
export const couponList = (params) => post('/web/service', params, { 'func': 'CP' })
//领券中心领取
export const couponReceive = (params) => post('/web/service', params, { 'func': 'RC' })
//积分商城列表
export const integralMallList = (params) => post('/web/service', params, { 'func': 'GDP' })
//积分商城列表(未登录)
export const integralMallListNL = (params) => postNL('/web/service', params, { 'func': 'GDPNL' })
//积分商品详情
export const integralMallDetail = (params) => post('/web/service', params, { 'func': 'GDD' })
//积分商城详情(未登录)
export const integralMallDetailNL = (params) => postNL('/web/service', params, { 'func': 'GDDNL' })
//积分商城兑换
export const integralMallExchange = (params) => post('/web/service', params, { 'func': 'GGD' })
//任务列表
export const taskList = (params) => post('/web/service', params, { 'func': 'TP' })
//领取任务奖励
export const taskReceive = (params) => post('/web/service', params, { 'func': 'GTK' })
//完善生日信息
export const completeBirthday = (params) => post('/web/service', params, { 'func': 'MB' })
//成长值记录
export const growthRecord = (params) => post('/web/service', params, { 'func': 'GRR' })
//礼包领取记录
export const giftReceiveRecord = (params) => post('/web/service', params, { 'func': 'GTR' })
//兑换记录
export const exchangeRecord = (params) => post('/web/service', params, { 'func': 'GDR' })
//积分记录
export const integralRecord = (params) => post('/web/service', params, { 'func': 'PR' })
//优惠券数量
export const couponNum = (params) => post('/web/service', params, { 'func': 'CC' })
//我的优惠券列表
export const myCouponList = (params) => post('/web/service', params, { 'func': 'MCP' })
//修改生日
export const changeBirthday = (params) => post('/web/service', params, { 'func': 'UB' })
//专属客服绑定列表
export const vipServiceList = (params) => post('/web/service', params, { 'func': 'VBL' })
//激活专属客服
export const activateVipService = (params) => post('/web/service', params, { 'func': 'BVI' })

